/* import __COLOCATED_TEMPLATE__ from './bracket-config-editor-bracket.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class BracketConfigEditorBracketComponent extends Component
{
	@action updateName(event)
	{
		this.args.onUpdate({ ...this.args.bracket, name: event.target.value });
	}

	// Results management
	@action addResult()
	{
		const newResults = [...this.args.bracket.results, { name: '', fileName: '' }];
		this.args.onUpdate({ ...this.args.bracket, results: newResults });
	}

	@action removeResult(resultIndex)
	{
		const newResults = this.args.bracket.results.filter((_, i) => i !== resultIndex);
		this.args.onUpdate({ ...this.args.bracket, results: newResults });
	}

	@action updateResultField(resultIndex, field, event)
	{
		const newResults = [...this.args.bracket.results];
		newResults[resultIndex] = { ...newResults[resultIndex], [field]: event.target.value };
		this.args.onUpdate({ ...this.args.bracket, results: newResults });
	}

	// Column management
	@action addColumn()
	{
		const newConfig = [...this.args.bracket.config, []];
		this.args.onUpdate({ ...this.args.bracket, config: newConfig });
	}

	@action removeColumn(columnIndex)
	{
		const newConfig = this.args.bracket.config.filter((_, i) => i !== columnIndex);
		this.args.onUpdate({ ...this.args.bracket, config: newConfig });
	}

	// Card management within columns
	@action addCard(columnIndex)
	{
		const newConfig = [...this.args.bracket.config];
		const newColumn = [...newConfig[columnIndex], {
			type: 'FIS',
			name: 'New Card',
			showBFinal: false,
			quarterfinalsClassGroups: [],
			semifinalsClassGroups: [],
			finalsClassGroups: []
		}];
		newConfig[columnIndex] = newColumn;
		this.args.onUpdate({ ...this.args.bracket, config: newConfig });
	}

	@action removeCard(columnIndex, cardIndex)
	{
		const newConfig = [...this.args.bracket.config];
		const newColumn = newConfig[columnIndex].filter((_, i) => i !== cardIndex);
		newConfig[columnIndex] = newColumn;
		this.args.onUpdate({ ...this.args.bracket, config: newConfig });
	}

	@action updateCard(columnIndex, cardIndex, updatedCard)
	{
		const newConfig = [...this.args.bracket.config];
		const newColumn = [...newConfig[columnIndex]];
		newColumn[cardIndex] = updatedCard;
		newConfig[columnIndex] = newColumn;
		this.args.onUpdate({ ...this.args.bracket, config: newConfig });
	}
}
